import { defineComponent as _defineComponent } from 'vue';
import { computed, watch } from "vue";
import { useToolStore } from "@/stores/toolStore";
import { useWorkflowStore } from "@/stores/workflowStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowStepTitle',
    props: {
        stepIndex: null,
        stepLabel: null,
        stepType: null,
        stepToolId: null,
        stepSubworkflowId: null
    },
    setup(__props) {
        const props = __props;
        const workflowStore = useWorkflowStore();
        const toolStore = useToolStore();
        const subWorkflow = computed(() => {
            if (props.stepSubworkflowId) {
                return workflowStore.getStoredWorkflowByInstanceId(props.stepSubworkflowId);
            }
            return null;
        });
        const toolName = computed(() => {
            if (props.stepToolId) {
                return toolStore.getToolNameById(props.stepToolId);
            }
            return "";
        });
        const title = computed(() => {
            const oneBasedStepIndex = props.stepIndex + 1;
            if (props.stepLabel) {
                return `Step ${oneBasedStepIndex}: ${props.stepLabel}`;
            }
            const workflowStepType = props.stepType;
            switch (workflowStepType) {
                case "tool":
                    return `Step ${oneBasedStepIndex}: ${toolName.value}`;
                case "subworkflow": {
                    const subworkflow = subWorkflow.value;
                    const label = subworkflow ? subworkflow.name : "Subworkflow";
                    return `Step ${oneBasedStepIndex}: ${label}`;
                }
                case "parameter_input":
                    return `Step ${oneBasedStepIndex}: Parameter input`;
                case "data_input":
                    return `Step ${oneBasedStepIndex}: Data input`;
                case "data_collection_input":
                    return `Step ${oneBasedStepIndex}: Data collection input`;
                default:
                    return `Step ${oneBasedStepIndex}: Unknown step type '${workflowStepType}'`;
            }
        });
        function initStores() {
            if (props.stepToolId && !toolStore.getToolForId(props.stepToolId)) {
                toolStore.fetchToolForId(props.stepToolId);
            }
            if (props.stepSubworkflowId) {
                workflowStore.fetchWorkflowForInstanceId(props.stepSubworkflowId);
            }
        }
        watch(props, () => {
            initStores();
        }, { immediate: true });
        return { __sfc: true, props, workflowStore, toolStore, subWorkflow, toolName, title, initStores };
    }
});
